module.exports = __webpack_public_path__ + "img/sven-deutschlaender.efe85db7.jpg";